import React from 'react';

import { CSVHelpInfo } from '@trqk/components';
import { locale, getSupportedProsLabel } from '@trqk/utils';

const supportedProsLabel = getSupportedProsLabel('and');

/**
 * A toast message shown when the backend detects that a .csv is not a valid statement.
 */
export const InvalidStatement = (): JSX.Element => (
    <div style={{ width: 500 }} className="px-2">
        <div className="font-bold text-highlight-orange tracking-wider mb-1">
            {locale.enUS.INGESTION.TOASTS.STATEMENT_FAILURE.INGESTION_ISSUE}
        </div>
        <div className="my-2">
            {
                locale.enUS.INGESTION.TOASTS.STATEMENT_FAILURE.INVALID_STATEMENT
                    .PART_1
            }
            &nbsp;
            {`${locale.enUS.SUPPORTED_PROS} ${supportedProsLabel}.`}
        </div>
        <div className="mt-6 mb-2 font-semibold">
            {
                locale.enUS.INGESTION.TOASTS.STATEMENT_FAILURE.INVALID_STATEMENT
                    .PART_2
            }
        </div>
        <div className="mb-4">
            <ol className="list-decimal leading-loose">
                <li>
                    {
                        locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS.STEP_1
                            .PART_1
                    }
                    &nbsp;
                    <span className="font-bold">
                        {
                            locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS
                                .STEP_1.PART_2
                        }
                    </span>
                </li>
                <li>
                    {
                        locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS.STEP_2
                            .PART_1
                    }
                    &nbsp;
                    <span className="font-bold">
                        {
                            locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS
                                .STEP_2.PART_2
                        }
                    </span>
                </li>
                <li>{locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS.STEP_3}</li>
            </ol>
        </div>
        <CSVHelpInfo />
    </div>
);
